import { render, staticRenderFns } from "./ConversionSettingsIndex.vue?vue&type=template&id=0f45a81d&scoped=true"
import script from "./ConversionSettingsIndex.vue?vue&type=script&lang=ts"
export * from "./ConversionSettingsIndex.vue?vue&type=script&lang=ts"
import style0 from "./ConversionSettingsIndex.vue?vue&type=style&index=0&id=0f45a81d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f45a81d",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/client-settings/conversion/conversion-settings-index.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2Fclient-settings%2Fconversion%2FConversionSettingsIndex.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports